export default "__VITE_ASSET__CWQfBTuf__"